import { render, staticRenderFns } from "./wxmpQrCodePic.vue?vue&type=template&id=3b43c8f7&scoped=true"
import script from "./wxmpQrCodePic.vue?vue&type=script&lang=js"
export * from "./wxmpQrCodePic.vue?vue&type=script&lang=js"
import style0 from "./wxmpQrCodePic.vue?vue&type=style&index=0&id=3b43c8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43c8f7",
  null
  
)

export default component.exports